var _circle, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewardsCards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 28,
    fill: "#FFF9DD",
    stroke: "#FFE673",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3638 30.8943L32.9161 30.2548C32.7421 30.2299 32.5768 30.1631 32.4343 30.0602C32.2918 29.9574 32.1764 29.8214 32.098 29.6641L30.1086 25.6733C30.002 25.4634 29.8393 25.2871 29.6386 25.1639C29.438 25.0408 29.2071 24.9756 28.9717 24.9756C28.7362 24.9756 28.5054 25.0408 28.3047 25.1639C28.1041 25.2871 27.9414 25.4634 27.8348 25.6733L25.8454 29.6641C25.7671 29.8214 25.6518 29.9572 25.5094 30.06C25.367 30.1628 25.2017 30.2295 25.0278 30.2543L20.5796 30.8943C20.3447 30.9241 20.1234 31.0207 19.9418 31.1725C19.7602 31.3243 19.6259 31.525 19.5549 31.7508C19.4812 31.9713 19.4722 32.2083 19.5292 32.4337C19.5861 32.6591 19.7066 32.8634 19.8762 33.0224L23.0948 36.1282C23.2216 36.2501 23.3166 36.4013 23.3715 36.5684C23.4264 36.7356 23.4394 36.9136 23.4095 37.087L22.6493 41.4724C22.6075 41.7007 22.6317 41.9362 22.7192 42.1512C22.8067 42.3663 22.9538 42.5518 23.1431 42.6861C23.3348 42.8292 23.5634 42.9147 23.802 42.9324C24.0406 42.9501 24.2793 42.8992 24.49 42.7858L28.4683 40.7156C28.6241 40.6347 28.797 40.5925 28.9724 40.5925C29.1479 40.5925 29.3208 40.6347 29.4765 40.7156L33.4543 42.7858C33.6651 42.8991 33.9037 42.9499 34.1423 42.9322C34.3809 42.9145 34.6095 42.8291 34.8012 42.6861C34.9906 42.5518 35.1377 42.3663 35.2252 42.1512C35.3126 41.9362 35.3369 41.7007 35.2951 41.4724L34.5348 37.0875C34.5049 36.9139 34.518 36.7357 34.573 36.5683C34.6279 36.401 34.7231 36.2497 34.8501 36.1277L38.0682 33.0224C38.2378 32.8634 38.3582 32.6591 38.4152 32.4337C38.4721 32.2083 38.4632 31.9713 38.3894 31.7508C38.3184 31.5249 38.184 31.3241 38.0022 31.1722C37.8204 31.0204 37.5988 30.9239 37.3638 30.8943Z",
    fill: "url(#paint0_linear_1351_3018)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9355 16.9954C42.9355 16.4662 42.7253 15.9586 42.3511 15.5844C41.9769 15.2102 41.4693 15 40.9401 15H16.9954C16.4662 15 15.9586 15.2102 15.5844 15.5844C15.2102 15.9586 15 16.4662 15 16.9954V17.4942H42.9355V16.9954Z",
    fill: "url(#paint1_linear_1351_3018)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.4922H42.9355V20.4876H15V18.4922Z",
    fill: "url(#paint2_linear_1351_3018)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9355 21.4854H15V29.9658C15 30.495 15.2102 31.0025 15.5844 31.3767C15.9586 31.7509 16.4662 31.9612 16.9954 31.9612H18.5039C18.5393 31.4488 18.7507 30.9643 19.1024 30.59C19.454 30.2156 19.9243 29.9743 20.4335 29.9069L24.8812 29.2674C24.8957 29.2653 24.9096 29.2597 24.9214 29.251C24.9332 29.2423 24.9427 29.2308 24.949 29.2175L26.9384 25.2267C27.1276 24.8507 27.4176 24.5347 27.7759 24.3139C28.1342 24.093 28.5469 23.9761 28.9678 23.9761C29.3887 23.9761 29.8013 24.093 30.1596 24.3139C30.5179 24.5347 30.8079 24.8507 30.9971 25.2267L32.9865 29.2175C32.993 29.2307 33.0026 29.2422 33.0145 29.2509C33.0264 29.2596 33.0402 29.2652 33.0548 29.2674L37.5021 29.9064C38.0113 29.9738 38.4816 30.2152 38.8333 30.5896C39.185 30.9641 39.3963 31.4487 39.4316 31.9612H40.9401C41.4693 31.9612 41.9769 31.7509 42.3511 31.3767C42.7253 31.0025 42.9355 30.495 42.9355 29.9658V21.4854ZM19.9885 27.4715H16.9954C16.8631 27.4715 16.7362 27.419 16.6427 27.3254C16.5491 27.2319 16.4965 27.105 16.4965 26.9727C16.4965 26.8404 16.5491 26.7135 16.6427 26.6199C16.7362 26.5264 16.8631 26.4738 16.9954 26.4738H19.9885C20.1208 26.4738 20.2477 26.5264 20.3412 26.6199C20.4348 26.7135 20.4873 26.8404 20.4873 26.9727C20.4873 27.105 20.4348 27.2319 20.3412 27.3254C20.2477 27.419 20.1208 27.4715 19.9885 27.4715ZM22.9816 24.9773H16.9954C16.8631 24.9773 16.7362 24.9247 16.6427 24.8312C16.5491 24.7376 16.4965 24.6107 16.4965 24.4784C16.4965 24.3461 16.5491 24.2193 16.6427 24.1257C16.7362 24.0322 16.8631 23.9796 16.9954 23.9796H22.9816C23.1139 23.9796 23.2408 24.0322 23.3343 24.1257C23.4279 24.2193 23.4804 24.3461 23.4804 24.4784C23.4804 24.6107 23.4279 24.7376 23.3343 24.8312C23.2408 24.9247 23.1139 24.9773 22.9816 24.9773Z",
    fill: "url(#paint3_linear_1351_3018)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1351_3018",
    x1: 23.8789,
    y1: 35.1301,
    x2: 38.3159,
    y2: 35.1265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1351_3018",
    x1: 21.4634,
    y1: 16.4102,
    x2: 42.7346,
    y2: 16.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1351_3018",
    x1: 21.4634,
    y1: 19.6204,
    x2: 42.7345,
    y2: 19.5489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1351_3018",
    x1: 21.4634,
    y1: 27.4083,
    x2: 42.7348,
    y2: 27.3947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsCards);
export default __webpack_public_path__ + "static/media/Rewards Cards.c2d81c74ebf9b5d5da6c9bf7c5e03e76.svg";
export { ForwardRef as ReactComponent };